import { Dispatch, SetStateAction } from "react";
import { useTranslation } from "react-i18next";

import background from "../../assets/images/menu/disney/background.png";
import CopyrightFooter from "../../components/copyrightFooter/CopyrightFooter";
import Text from "../../components/ui/Text";
import useStore from "../../hooks/store/useStore";
import { MenuItemType } from "../../types";
import BookButton from "../bookDemo/BookButton";
import DisneyMenuBubbles from "./DisneyMenuBubbles";

export default function DisneyMenu({
  setSelectedMenuItem,
  setShowDisneyMenu,
}: {
  setSelectedMenuItem: Dispatch<SetStateAction<MenuItemType>>;
  setShowDisneyMenu: Dispatch<SetStateAction<boolean | null>>;
}) {
  const { t } = useTranslation();
  const { userInformation } = useStore((state) => state.user);
  const { market } = userInformation || {};

  return (
    <div className="relative flex min-h-screen w-full justify-center bg-pink1">
      <div className="flex min-h-screen w-screen min-w-[320px] flex-col bg-pink1">
        <div className="flex h-11 items-center justify-center">
          <Text lg className="font-medium">
            {t("digitalExperience")}
          </Text>
        </div>

        <div className="mx-auto mb-6 mt-4 max-w-[480px] px-10 tablet-lg:my-12">
          <Text className="text-center">{t("disneyDescription")}</Text>
        </div>

        <div
          className="relative flex flex-1 flex-col items-center justify-start bg-cover bg-top pt-10"
          style={{ backgroundImage: `url(${background})` }}
        >
          <div className="[@media(min-height:800px)]:my-auto">
            <DisneyMenuBubbles
              setSelectedMenuItem={setSelectedMenuItem}
              setShowDisneyMenu={setShowDisneyMenu}
              hasBedtime={market === "HK"}
            />
          </div>

          <CopyrightFooter className="mt-auto" />
        </div>

        <BookButton sourcePage="Disney Menu" />
      </div>
    </div>
  );
}
